<template>
  <div class="flex flex-col gap-sm">
    <div class="flex gap-l flex-spacer">
      <h3 class="flex secondary-font primary-font-color label-xxl-400 text-align-left text-nowrap">
        <slot name="title"/>
      </h3>
      <div class="flex width-100 hidden-xs">
        <hr :class="`spacer my-2`" />
      </div>
    </div>
    <div class="flex flex-col gap-sm" v-if="$slots.description">
      <p class="flex secondary-font primary-font-color label-sm-400 text-nowrap">
        <slot name="description"/>
      </p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
$height: 2px;

hr {
  border: none;
  border-top: $height solid var(--primary-40, #FED68E);
  opacity: 0.7;
  height: $height;
  width: 100%;
}

.text-nowrap {
  white-space: nowrap;
  @media screen and (max-width: 240px) {
    white-space: normal;
    text-align: center;
  }
}

.my-2 {
  margin-top: calc(0.75rem + $height);
  margin-bottom: 0.5rem;
}

.flex-spacer {
  display: flex;
  flex-direction: row;
  gap: var(--gap-l, 1.5rem);
  @media screen and (max-width: 240px) {
    justify-content: center;
    text-align: center;
  }
}

.hidden-xs {
  @media screen and (max-width: 240px) {
    display: none;
  }
}
</style>
